import React, { useEffect, useState } from 'react';

import BuzzerDisplay from './BuzzerDisplay';
import mqtt from 'mqtt';

function Shell() {
    const [message, setMessage] = useState('');
    const [backgroundColor, setBackgroundColor] = useState('');

    useEffect(() => {
        const client = mqtt.connect('wss://mqtt.thegrayportal.com:9001');

        client.on('connect', () => {
            console.log('Connected to MQTT broker');
            client.subscribe('test/topic', (err) => {
                if (!err) {
                    console.log('Subscribed to topic');
                } else {
                    console.error('Error subscribing:', err);
                }
            });
        });
        client.on('message', (topic, payload) => {
            console.log(`Received message: ${payload.toString()}`);
            const str = payload.toString();
            if (str === 'reset') {
                setMessage('');
                setBackgroundColor('');
            }
            else if (str === '0') {
                setMessage('Team Power BI');
                setBackgroundColor('powerbi');
            }
            else if (str === '1') {
                setMessage('Team Fabric');
                setBackgroundColor('fabric');
            }
        });

        return () => {
            client.end();
        };
    }, []);

    return <BuzzerDisplay teamName={message} backgroundColor={backgroundColor} />
};

export default Shell;
